import PropTypes from 'prop-types'
import { IconButton } from '@chakra-ui/react'

export const NormalIconButton = ({ children, p = '0px', width = '37px', height = '37px', minW = '28px', ...props }) => {
  return (
    <IconButton variant="outline" p={p} width={width} height={height} minW={minW} {...props}>
      {children}
    </IconButton>
  )
}

NormalIconButton.propTypes = {
  children: PropTypes.node.isRequired,
}
